module.exports = __webpack_public_path__ + "static/img/Sam-Walker.2cb7c9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Walker.jpg
// module id = x7Ia
// module chunks = 0